<template>
  <div class="legend-wrapper">
    <div class="legend-title">Model Predictions</div>
    <div
      class="race-state"
      :style="'background-color: ' + item.color"
      v-for="(item, index) in legendItems"
      :key="index">
      <span :style="`color: ${item.textColor};`">{{ item.state }}</span>
    </div>
  </div>
</template>

<script>
import Utils from '@/utils'

const computed = {
  legendItems () {
    return Utils.colorScale
  }
}

export default {
  name: 'PredictionLegend',
  computed
}
</script>

<style>
.legend-wrapper {
  text-align: center;
}

.legend-wrapper .race-state {
  display: inline-block;
  font-size: 11px;
  margin: 2px;
}

.legend-title {
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 2px;
}
</style>
